import { useMutation } from "react-query";
import api from "../../client";
import { AuthVerifyEmailPayload } from "../../types/auth";

const postData = async (payload: AuthVerifyEmailPayload): Promise<any> => {
  const { data } = await api.post(`/auth/email-verification-resend`, payload);

  return data;
};

export const useVerifyEmail = () => {
  return useMutation((payload: AuthVerifyEmailPayload) => {
    return postData(payload);
  });
};
